import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet, apiPost } from '../api';
import { IUploadCatalogResponse } from 'types/bulkUpload';

const { REACT_APP_CATALOG } = process.env;

export const uploadCatalog = async (
  file: File,
  replaceCatalogue: boolean,
  countryId: number
): Promise<IUploadCatalogResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append(
    'body',
    JSON.stringify({
      cleanCatalog: replaceCatalogue,
      countryId
    })
  );

  return apiPost<AxiosRequestConfig, FormData>(`${REACT_APP_CATALOG}bulk-upload/catalog`, formData)
    .then(response => Promise.resolve(response.data))
    .catch((error: AxiosError) => {
      const message = error.response?.data?.message;
      return Promise.reject(error.response?.status === 400 && message ? new SyntaxError(message) : error);
    });
};

export const downloadTemplate = async (
  countryId: number,
  productTypeId: number,
  onlyActiveProducts: boolean | null,
  includeQuoteProducts: boolean | null
): Promise<{ url: string }> => {
  return apiGet<AxiosRequestConfig, { url: string }>(
    `${REACT_APP_CATALOG}bulk-upload/generate-catalog-document/${countryId}`,
    {
      params: {
        exchangeId: productTypeId,
        active: onlyActiveProducts,
        includeQuoteProducts
      }
    }
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const downloadTemplateWithoutData = async (): Promise<string> => {
  return apiGet<AxiosRequestConfig, { url: string }>(`${REACT_APP_CATALOG}bulk-upload/template-catalog`)
    .then(response => Promise.resolve(response.url))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const downloadProductsToQuoteTemplate = async (countryId: number): Promise<string> => {
  return apiGet<AxiosRequestConfig, { url: string }>(
    `${REACT_APP_CATALOG}bulk-upload/generate-quote-catalog-document/${countryId}`
  )
    .then(response => Promise.resolve(response.url))
    .catch((error: AxiosError) => Promise.reject(error));
};
